/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAdmissionStatusOptionsRequest
 */
export interface FindAdmissionStatusOptionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAdmissionStatusOptionsRequest
     */
    lead_ids: Array<string>;
}

/**
 * Check if a given object implements the FindAdmissionStatusOptionsRequest interface.
 */
export function instanceOfFindAdmissionStatusOptionsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;

    return isInstance;
}

export function FindAdmissionStatusOptionsRequestFromJSON(json: any): FindAdmissionStatusOptionsRequest {
    return FindAdmissionStatusOptionsRequestFromJSONTyped(json, false);
}

export function FindAdmissionStatusOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAdmissionStatusOptionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
    };
}

export function FindAdmissionStatusOptionsRequestToJSON(value?: FindAdmissionStatusOptionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
    };
}

